import { get, post } from '@/request/http'

/**
 * 官网公共接口集中出口。
 *
 * 页面后续应优先调用本文件导出的函数，而不是在组件中直接拼写接口路径。
 */
export const getWebsiteHome = (lang) => get('public/website/home', { lang })

export const getWebsiteScales = (params) => get('public/website/scales',
  typeof params === 'string' ? { lang: params } : (params || {})
)

export const getWebsiteScaleDetail = (slug, lang) => get(`public/website/scales/${slug}/detail`, { lang: lang || 'zh' })

export const getWebsiteTrainingSessions = (params) => get('public/website/training-sessions', params)

export const getWebsiteExperts = (params) => get('public/website/experts', params)

export const getWebsiteNews = (params) => get('public/website/news', params)

export const getWebsiteNewsDetail = (id, lang) => get(`public/website/news/${id}`, { lang })

export const submitWebsiteConsultation = (data) => post('public/website/consultations', data)



// WEBPACK FOOTER //
// ./src/request/apis/website.js